

import Vue from 'vue'
import ElementUI, { MessageBox } from 'element-ui'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import htmlToPdf from '../src/assets/js/html2pdf'
import 'element-ui/lib/theme-chalk/index.css'
import util from './assets/js/util'

Vue.use(VueRouter)
Vue.use(AjaxPlugin)
Vue.use(ElementUI)
Vue.use(htmlToPdf)




const _origMessageBoxAlert = MessageBox.alert.bind(MessageBox)
MessageBox.alert = function (message, title, options) {
const text = typeof message === 'string' ? message : ''
if (text.indexOf('无法识别您的身份') !== -1) {
util.handleUnauthorized()
return Promise.resolve()
}
return _origMessageBoxAlert(message, title, options)
}

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js